import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalContent, ModalFooter, Button } from '@spoiler-alert/ui-library';

const rowCountOf = (profileDocument) =>
  (profileDocument.mappings?.length ?? 0) +
  (profileDocument.defaults?.length ?? 0) +
  (profileDocument.columns?.length ?? 0);

const describeSource = ({ source, exportedAt }) => {
  const environment = source?.environment ? `from ${source.environment}` : 'from an unknown environment';
  const site = source?.siteName ? ` (${source.siteName})` : '';
  const when = exportedAt ? ` on ${new Date(exportedAt).toLocaleString()}` : '';
  return `Exported ${environment}${site}${when}`;
};

/**
 * Confirms a parsed profile upload.
 *
 * Receives the already-parsed document, so it can name the profile being overwritten and where
 * the file came from.
 */
const ProfileUploadConfirmationModal = ({ pendingUpload, targetDescription, onConfirm, onCancel, uploading }) => (
  <Modal onHide={onCancel} open={!!pendingUpload} closeOnEsc closeOnOutsideClick>
    <ModalContent>
      <h2>Upload this profile?</h2>
      {pendingUpload && (
        <div>
          <p>
            This will overwrite <strong>{targetDescription}</strong>, replacing its rows with the{' '}
            {rowCountOf(pendingUpload.document)} in this file.
          </p>
          <p>
            {pendingUpload.filename}
            <br />
            {describeSource(pendingUpload.document)}
          </p>
          <p>We recommend downloading the current profile first, so you can put it back if you need to.</p>
        </div>
      )}
    </ModalContent>
    <ModalFooter>
      <Button type="button" onClick={onCancel} link disabled={uploading}>
        Cancel
      </Button>
      <Button type="button" primary onClick={onConfirm} loading={uploading} loadingText="Uploading">
        Yes, upload it
      </Button>
    </ModalFooter>
  </Modal>
);

ProfileUploadConfirmationModal.propTypes = {
  pendingUpload: PropTypes.object,
  targetDescription: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  uploading: PropTypes.bool,
};

export default ProfileUploadConfirmationModal;
